<template>
  <div>
    <v-container>
      <InscriptionsFilters v-model="display_params" :mode="mode" :course-select="course_select"
        :billetterie-mode="mainStore.billetterie_mode" />
      <v-row>

        <v-col cols="12" class="d-flex justify-end align-center">
          <div class="text-body-1 font-weight-bold">{{ get_count_participants() }}</div>
        </v-col>
      </v-row>




    </v-container>
    <v-table density="compact" v-if="courses_by_id">
      <BilletterieInscriptionThead :mode="mode" v-if="mainStore.billetterie_mode"></BilletterieInscriptionThead>
      <InscriptionThead v-else :mode="mode" :display_categorie_coureur="display_categorie_coureur"></InscriptionThead>

      <BilletterieInscriptionTbody :mode="mode" :inscriptions="inscriptions" :key="'bil' + update_key"
        v-if="mainStore.billetterie_mode">
      </BilletterieInscriptionTbody>
      <InscriptionTbody v-else :mode="mode" :inscriptions="inscriptions" :key="'ins' + update_key"
        :display_categorie_coureur="display_categorie_coureur" :courses_by_id="courses_by_id" @onValidPPS="loadList">
      </InscriptionTbody>

    </v-table>
    <div class="d-flex justify-end">
      <v-pagination density="compact" v-model="page" :length="get_length_pagination()"
        :total-visible="7"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
import axios from "axios";
import InscriptionsFilters from "./InscriptionsFilters.vue";
import BilletterieInscriptionThead from "./BilletterieInscriptionThead.vue";
import InscriptionThead from "./InscriptionThead.vue";
import BilletterieInscriptionTbody from "./BilletterieInscriptionTbody.vue";
import InscriptionTbody from "./InscriptionTbody.vue";
export default {
  components: {
    InscriptionsFilters,
    BilletterieInscriptionThead,
    InscriptionThead,
    BilletterieInscriptionTbody,
    InscriptionTbody,
  },
  props: ["mode"],
  data() {
    return {
      update_key: 0,
      base_url: process.env.VUE_APP_API_BASE,
      dialog: false,
      isRestoringSession: false,
      page: 1,
      display_params: {
        search_value: "",
        search_by: "nom",
        id_course: 0,
        page: 1,
        perPage: 30,
        sexe: "",
        categorie: "",
        hide_deleted: false,
        order_by: "dossard",
        order_dir: "ASC",
      },
      count_match_query: 0,
      inscriptions: [],
      courses: [],
    };
  },
  watch: {
    display_params: {
      handler: function () {
        if (this.isRestoringSession) return;
        this.page = 1;
        this.saveSessionFilters();
        this.loadList();
      },
      deep: true,
    },
    page() {
      if (this.isRestoringSession) return;
      this.saveSessionFilters();
      this.loadList();
    },
  },

  computed: {
    ...mapStores(useMainStore),

    courses_by_id() {
      let courses = {};
      this.courses.forEach((course) => {
        courses[course.id] = course;
      });
      return courses;
    },
    course_select() {
      let res = [{ text: "Tous", value: 0 }];
      let courses = this.courses.map((course) => {
        return {
          text: course.nom,
          value: course.id,
        };
      });
      return res.concat(courses);
    },
    display_categorie_coureur() {
      if (this.display_params.id_course == 0) {
        return true;
      }
      let selected_course = this.courses_by_id[this.display_params.id_course];
      for (let i = 0; i < selected_course.metadatas.length; i++) {
        if (selected_course.metadatas[i].nom == "est_chronometre" && selected_course.metadatas[i].valeur == "0") {
          return false;
        }
      }
      return true;
    },
  },

  methods: {
    getSessionStorageKey() {
      return `inscriptions_list_filters_${this.mode || "public"}_${this.mainStore.module.id}`;
    },
    saveSessionFilters() {
      sessionStorage.setItem(
        this.getSessionStorageKey(),
        JSON.stringify({
          display_params: this.display_params,
          page: this.page,
        })
      );
    },
    restoreSessionFilters() {
      const stored = sessionStorage.getItem(this.getSessionStorageKey());
      if (!stored) return;

      try {
        const { display_params, page } = JSON.parse(stored);
        this.isRestoringSession = true;
        if (display_params) {
          this.display_params = { ...this.display_params, ...display_params };
        }
        if (page) {
          this.page = page;
        }
      } catch (e) {
        sessionStorage.removeItem(this.getSessionStorageKey());
      } finally {
        this.isRestoringSession = false;
      }
    },

    get_length_pagination() {
      return Math.ceil(this.count_match_query / this.display_params.perPage);
    },
    get_count_participants() {
      if (this.inscriptions.length == 0) return "0 participant(s)";
      let current_page_offset = (this.display_params.page - 1) * this.display_params.perPage + 1;
      let current_page_count = current_page_offset + this.inscriptions.length - 1;
      return current_page_offset + " à " + current_page_count + " / " + this.count_match_query + " participants";
    },



    async loadList() {
      let params = this.get_request_params();
      let request = await AdminService.getInscriptions(params);
      if (request) {
        this.inscriptions = request.list;
        this.count_match_query = request.count_match_query;
      }
      this.update_key++;
    },
    get_request_params() {
      let params = "";
      params += "id_module=" + this.mainStore.module.id;
      const searchVal = this.display_params.search_value || "";
      if (searchVal != "") {
        if (this.display_params.search_by == "search_commande") {
          params += "&search_commande=" + searchVal;
        } else if (this.display_params.search_by == "mail") {
          params += "&search_mail=" + searchVal;
        } else {
          params += "&search=" + searchVal;
        }
      }
      if (this.display_params.id_course != 0) {
        params += "&id_course=" + this.display_params.id_course;
      }
      if (this.page != 1) {
        params += "&page=" + this.page;
      }
      if (this.display_params.order_by != "nom") {
        params += "&order_by=" + this.display_params.order_by;
      }
      if (this.display_params.sexe != "") {
        params += "&sexe=" + this.display_params.sexe;
      }
      if (this.display_params.categorie != "") {
        params += "&categorie=" + this.display_params.categorie;
        params += "&event_date=" + this.mainStore.module.evenement.date_debut;
      }
      if (this.display_params.order_dir != "ASC") {
        params += "&order_dir=" + this.display_params.order_dir;
      }
      if (this.mode == "admin") {
        params += "&admin=1";
      }

      if (this.display_params.hide_deleted) {
        params += "&hide_deleted=1";
      }
      return params;
    },
    async loadCourses() {
      let res = await axios.get("/courses/get.php?id_module=" + this.mainStore.module.id);

      if (res.data.error) {
        console.log(res.data.error);
        return await false;
      } else {
        this.courses = res.data;
        return await true;
      }
    },
  },
  async created() {
    await this.loadCourses();
    this.restoreSessionFilters();
    await this.loadList();
  },
};
</script>

<style lang="scss" scoped></style>